import React, { useState } from 'react';
import './ReceivedPayForm.css';

const ReceivedPay = () => {
    const [formData, setFormData] = useState({
        customerName: '',
        type: 'Cash',
        cheqRecNo: '',
        cheqRecDt: '',
        receivDt: '',
        recvName: '',
        amount: '',
        tds: '',
        discount: '',
        remark: '',
        depositBank: '',
    });

    const handleChange = (e: { target: { name: any; value: any; }; }) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleAdd = () => {
        console.log('Add:', formData);
    };

    const handleModify = () => {
        console.log('Modify:', formData);
    };

    const handleDelete = () => {
        console.log('Delete:', formData);
    };

    return (
        <div className="received-pay-container">
            <h4 className="text-center">Payment Received</h4>


            <div className="container">
                <div className="row">
                    <div className="col-lg-6">

                        <div className="form-row">
                            <label>Customer Name</label>
                            <input type="text" name="customerName" value={formData.customerName} onChange={handleChange} />
                        </div>
                        <div className="form-row">
                            <select name="type" value={formData.type} onChange={handleChange}>
                                <option>Cash</option>
                                <option>Cheque</option>
                                <option>Online</option>
                            </select>

                            <label>Cheq/Rec No</label>
                            <input type="text" name="cheqRecNo" value={formData.cheqRecNo} onChange={handleChange} />
                        </div>
                        <div className="form-row">
                            <label>Cheq/Rec Date</label>
                            <input type="date" name="cheqRecDt" value={formData.cheqRecDt} onChange={handleChange} />

                            <label>Receiv Date</label>
                            <input type="date" name="receivDt" value={formData.receivDt} onChange={handleChange} />
                        </div>
                        <div className="form-row">
                            <label>Recv Name</label>
                            <input type="text" name="recvName" value={formData.recvName} onChange={handleChange} />
                        </div>
                    </div>
                    <div className="col-lg-6">

                        <div className="form-row">
                            <label>Amount</label>
                            <input type="text" name="amount" value={formData.amount} onChange={handleChange} />

                            <label>TDS</label>
                            <input type="text" name="tds" value={formData.tds} onChange={handleChange} />

                            <label>Discount/Debit</label>
                            <input type="text" name="discount" value={formData.discount} onChange={handleChange} />
                        </div>
                        <div className="form-row">
                            <label>Remark</label>
                            <input type="text" name="remark" value={formData.remark} onChange={handleChange} />

                            <label>Deposit Bank</label>
                            <input type="text" name="depositBank" value={formData.depositBank} onChange={handleChange} />
                        </div>
                    </div>
                </div>
            </div>
















            <div className="button-group">
                <button className="button-add" onClick={handleAdd}>Add</button>
                <button className="button-modify" onClick={handleModify}>Modify</button>
                <button className="button-delete" onClick={handleDelete}>Delete</button>
                <button className="button-close">Close</button>
            </div>
        </div>
    );
};

export default ReceivedPay;
